import { render, staticRenderFns } from "./Manage-Supplier.vue?vue&type=template&id=d222cab0"
import script from "./Manage-Supplier.vue?vue&type=script&lang=js"
export * from "./Manage-Supplier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports